import Vue from 'vue'
import VueRouter from 'vue-router'

// 导入组件
import Login from '@/views/auth/Login.vue'
import Register from '@/views/auth/Register.vue'
import Layout from '@/components/Layout.vue'
import PromotionLink from '@/views/promotion/PromotionLink.vue'
import MyPage from '@/views/user/MyPage.vue'
import MyDetails from '@/views/user/MyDetails.vue'
import RealNameVerification from '@/views/user/RealNameVerification.vue'
import OrderQuery from '@/views/order/OrderQuery.vue'
import PositionManagement from '@/views/admin/PositionManagement.vue'
import SiteManagement from '@/views/admin/SiteManagement.vue'
import GoodsList from '@/views/product/GoodsList.vue'
import ProductList from '@/views/product/ProductList.vue'
import PromotionGuidelines from '@/views/promotion/PromotionGuidelines.vue'
import ContactUs from '@/views/user/ContactUs.vue'
import ProductDetail from '@/views/product/ProductDetail.vue'
import Guide from '@/views/guide/Guide.vue'
import GuideManagement from '@/views/guide/GuideManagement.vue'
import LiberayManagement from '@/views/admin/LiberayManagement.vue'
import EnumValueManagement from '@/views/admin/EnumValueManagement.vue'
import OrderGroupQuery from '@/views/order/OrderGroupQuery.vue'
import MyInvites from '@/views/user/MyInvites.vue'
import InviteDetail from '@/views/user/InviteDetail.vue'
import CustomerAcquisitionGuide from '@/views/guide/CustomerAcquisitionGuide.vue'
import ProductManagement from '@/views/admin/ProductManagement.vue'
import ProductPage from '@/views/product/ProductPage.vue'
import ProductPageDetail from '@/views/product/ProductPageDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: '注册'
    }
  },
  {
    path: '/',
    component: Layout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        redirect: 'promotion'
      },
      {
        path: 'promotion',
        name: 'PromotionLink',
        component: PromotionLink,
        meta: {
          title: '推广链接'
        }
      },
      {
        path: 'mypage',
        name: 'MyPage',
        component: MyPage,
        meta: {
          title: '我的页面'
        }
      },
      {
        path: 'order-query',
        name: 'OrderQuery',
        component: OrderQuery,
        meta: {
          title: '订单查询'
        }
      },
      {
        path: 'goods-list',
        name: 'goodsList',
        component: GoodsList,
        meta: {
          title: '精选商品'
        }
      },
      {
        path: 'products',
        name: 'ProductPage',
        component: ProductPage,
        meta: {
          title: '商品',
          requiresAuth: true
        }
      },
      {
        path: 'product-list',
        name: 'ProductList',
        component: ProductList,
        meta: {
          title: '商品列表'
        }
      },
      {
        path: 'guide',
        name: 'Guide',
        component: Guide,
        meta: {
          title: '攻略'
        }
      },
    ]
  },
  {
    path: '/my-invites',
    name: 'MyInvites',
    component: MyInvites,
    meta: {
      title: '我的邀请',
      requiresAuth: true
    }
  },
  {
    path: '/invite-detail/:positionId',
    name: 'InviteDetail',
    component: InviteDetail,
    meta: {
      title: '邀请详情',
      requiresAuth: true
    }
  },
  {
    path: '/mydetails',
    name: 'MyDetails',
    component: MyDetails,
    meta: {
      title: '我的明细',
      requiresAuth: true
    }
  },
  {
    path: '/realname-verification',
    name: 'RealNameVerification',
    component: RealNameVerification,
    meta: {
      title: '实名认证',
      requiresAuth: true
    }
  },
  {
    path: '/promotion-guidelines',
    name: 'PromotionGuidelines',
    component: PromotionGuidelines,
    meta: {
      title: '推广规范',
      requiresAuth: true
    }
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: ContactUs,
    meta: {
      title: '联系我们',
      requiresAuth: true
    }
  },
  {
    path: '/product-detail',
    name: 'ProductDetail',
    component: ProductDetail,
    meta: {
      title: '商品详情',
      requiresAuth: true
    }
  },
  {
    path: '/product-page-detail',
    name: 'ProductPageDetail',
    component: ProductPageDetail,
    meta: {
      title: '商品详情',
      requiresAuth: true
    }
  },
  {
    path: '/guide-management',
    name: 'GuideManagement',
    component: GuideManagement,
    meta: {
      title: '攻略管理',
      requiresAuth: true
    }
  },
  {
    path: '/product-management',
    name: 'ProductManagement',
    component: ProductManagement,
    meta: {
      title: '商品管理',
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/liberay-management',
    name: 'LiberayManagement',
    component: LiberayManagement,
    meta: {
      title: '仓库管理',
      requiresAuth: true
    }
  },
      {
        path: '/enum-values',
        name: 'EnumValueManagement',
        component: EnumValueManagement,
        meta: {
          title: '枚举值管理',
          requiresAuth: true,
          requiresAdmin: true
        }
      },
  {
    path: '/position-management',
    name: 'PositionManagement',
    component: PositionManagement,
    meta: {
      title: '推广位管理',
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/site-management',
    name: 'SiteManagement',
    component: SiteManagement,
    meta: {
      title: '媒体ID管理',
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/order-group-query',
    name: 'OrderGroupQuery',
    component: OrderGroupQuery,
    meta: {
      title: '订单跟团查询',
      requiresAuth: false
    }
  },
  {
    path: '*',
    redirect: '/login'
  },
  {
    path: '/customer-acquisition-guide',
    name: 'CustomerAcquisitionGuide',
    component: CustomerAcquisitionGuide,
    meta: {
      title: '获客指南',
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫 - 检查登录状态
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    // document.title = to.meta.title
    document.title = 'dongdong-union'
  }

  const token = localStorage.getItem('token')

  // 未登录：除登录页、注册页和订单跟团查询页外一律跳转登录
  if (!token && to.path !== '/login' && to.path !== '/register' && to.path !== '/order-group-query') {
    next('/login')
    return
  }

  // 已登录且访问登录页，跳转到推广页面
  if (to.path === '/login' && token) {
    next('/promotion')
    return
  }

  // 检查是否需要管理员权限（匹配到的任意记录）
  const requiresAdmin = to.matched.some(record => record.meta && record.meta.requiresAdmin)
  if (requiresAdmin) {
    try {
      const userStr = localStorage.getItem('user')
      if (userStr) {
        const user = JSON.parse(userStr)
        if (user.role !== 'ADMIN') {
          // 避免循环重定向，检查当前路径
          if (to.path !== '/mypage') {
            next('/mypage')
            return
          }
        }
      } else {
        next('/login')
        return
      }
    } catch (error) {
      console.error('解析用户信息失败:', error)
      next('/login')
      return
    }
  }

  next()
})

export default router
